import { render, staticRenderFns } from "./Coding.vue?vue&type=template&id=dfadcb56&scoped=true"
import script from "./Coding.vue?vue&type=script&lang=js"
export * from "./Coding.vue?vue&type=script&lang=js"
import style0 from "./Coding.vue?vue&type=style&index=0&id=dfadcb56&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfadcb56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfadcb56')) {
      api.createRecord('dfadcb56', component.options)
    } else {
      api.reload('dfadcb56', component.options)
    }
    module.hot.accept("./Coding.vue?vue&type=template&id=dfadcb56&scoped=true", function () {
      api.rerender('dfadcb56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/Coding.vue"
export default component.exports